export const version = "abstract-provider/5.1.0";
